import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useRef } from "react";
import PropTypes from "prop-types";
import { extendedSystemStylesProps } from "@mixins";
import { equals } from "ramda";
import { Flex } from "@base-ui";
import { Label, SelectButton, Options, Option, OptionText } from "./select.styles";
import { useOpen, useClickOutside, useDebounce, useCustomEffect } from "hooks";
import handleKeyDown from "./handleKeyDown";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["color", "space", "layout", "flexbox", "border"];
var Select = function Select(props) {
  var _options$selected, _options$selected2;
  var id = props.id,
    label = props.label,
    _selected = props._selected,
    options = props.options,
    onChange = props.onChange,
    inverted = props.inverted,
    hideLabel = props.hideLabel,
    className = props.className,
    selectedPrefix = props.selectedPrefix,
    _props$debounce = props.debounce,
    debounce = _props$debounce === void 0 ? 1000 : _props$debounce;
  var _useState = useState(_selected),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  useDebounce(selected, debounce, onChange);
  var _useOpen = useOpen(false),
    open = _useOpen.open,
    setOpen = _useOpen.setOpen,
    toggleOpen = _useOpen.toggleOpen;
  var selectRef = useRef();
  var containerRef = useRef();
  var optionsRef = useRef();
  var clickSelect = function clickSelect(idx) {
    setSelected(idx);
    setOpen(false);
  };
  handleKeyDown(id, containerRef, selectRef, optionsRef, open, setOpen, selected, setSelected, options.length - 1);
  useClickOutside(containerRef, function () {
    return setOpen(false);
  }, open);
  useCustomEffect(function () {
    if (!equals(_selected, selected)) {
      setSelected(_selected);
    }
  }, [_selected]);
  var optionsMarkup = options.map(function (option, idx) {
    return /*#__PURE__*/_jsx(Option, {
      id: "".concat(id, "-option-").concat(idx),
      title: option.label,
      "aria-selected": selected === idx,
      selected: selected === idx,
      role: "option",
      onClick: function onClick() {
        return clickSelect(idx);
      },
      children: /*#__PURE__*/_jsx(OptionText, {
        children: option.label
      })
    }, option.id);
  });
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Label, {
      id: "".concat(id, "-label"),
      hideLabel: hideLabel,
      inverted: inverted,
      children: label
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      style: {
        position: "relative"
      },
      ref: containerRef,
      children: [/*#__PURE__*/_jsxs(SelectButton, {
        id: id,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-controls": "".concat(id, "-listbox"),
        "aria-labelledby": "".concat(id, "-label ").concat(id),
        open: open,
        ref: selectRef,
        inverted: inverted,
        title: (_options$selected = options[selected]) === null || _options$selected === void 0 ? void 0 : _options$selected.label,
        onClick: toggleOpen,
        children: [selectedPrefix, " ", (_options$selected2 = options[selected]) === null || _options$selected2 === void 0 ? void 0 : _options$selected2.label]
      }), /*#__PURE__*/_jsx(Options, {
        id: "".concat(id, "-listbox"),
        role: "listbox",
        "aria-labelledby": "".concat(id, "-label"),
        "aria-activedescendant": "".concat(id, "-option-").concat(selected),
        ref: optionsRef,
        tabIndex: -1,
        open: open,
        children: optionsMarkup
      })]
    })]
  }));
};
Select.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  _selected: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  inverted: PropTypes.bool,
  hideLabel: PropTypes.bool,
  className: PropTypes.string,
  selectedPrefix: PropTypes.any
};
Select.defaultProps = {
  _selected: 0,
  hideLabel: false
};
export default Select;